import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import './AboutPage.css'; // Nieuwe CSS bestand voor AboutPage
import HeroSlideshow from './HeroSlideshow';

const AboutPage = () => {
  const { t } = useLanguage();
  
  return (
    <>
      <HeroSlideshow />
      
      <div className="description-block">
        <h2 className="description-title">{t('contactTitle', 'Contact en informatie')}</h2>
        <div className="description-content">
          <p>{t('contactDesc', 'Hier vindt u onze contactgegevens en meer informatie over Mediahuis tariefcalculator')}</p>
        </div>
      </div>
      
      <div className="home-page">
        <div className="contact-section">
          <div className="contact-info">
            <h3>{t('contactDetails', 'Contactgegevens')}</h3>
            <div className="contact-detail">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <div className="contact-text">
                <strong>{t('phone', 'Telefoon')}:</strong>
                <p>088-824 2222</p>
              </div>
            </div>
            
            <div className="contact-detail">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div className="contact-text">
                <strong>{t('email', 'E-mail')}:</strong>
                <p><a href="mailto:samenwerken@mediahuis.nl">samenwerken@mediahuis.nl</a></p>
              </div>
            </div>
            
            <div className="contact-detail">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div className="contact-text">
                <strong>{t('address', 'Adres')}:</strong>
                <p>Mediahuis Nederland B.V.</p>
                <p>Basisweg 30, 1043 AP Amsterdam</p>
              </div>
            </div>
          </div>
          
          <div className="about-info">
            <h3>{t('aboutTheCalculator', 'Over de tariefcalculator')}</h3>
            <p>{t('calculatorPurpose', 'Met onze tariefcalculator kunt u eenvoudig prijzen bekijken en vergelijken voor advertenties in al onze mediaproducten. U kunt zoeken op type media, titel, of specifieke regio.')}</p>
            <p>{t('calculatorFeatures', 'Enkele functies:')}</p>
            <ul>
              <li>{t('featureSearch', 'Zoeken op media type, titel of regio')}</li>
              <li>{t('featureCompare', 'Prijzen vergelijken tussen verschillende producten')}</li>
              <li>{t('featureExport', 'Mediaplan exporteren')}</li>
              <li>{t('featureQuote', 'Direct offerte aanvragen')}</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutPage; 